export default {
      id: "book-menu-usage",
      viewBox: "0 0 4 14",
      url: __webpack_public_path__ + "sprite.svg#book-menu-usage",
      toString: function () {
        return this.url;
      }
    }